import { FirebaseError, initializeApp } from "firebase/app";

import { getAuth, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { LoginRequest } from "../store/services/auth-api/types";

const firebaseConfig = {
  apiKey: "AIzaSyAwIC5RBT2i5XzDxLu1QlH8ZQY1uQAn8Kw",
  authDomain: "idtagtech.firebaseapp.com",
  projectId: "idtagtech",
  storageBucket: "idtagtech.appspot.com",
  messagingSenderId: "681116714182",
  appId: "1:681116714182:web:fb61f87fec4d835c97c3c7",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

const logInWithEmailAndPassword = (credentials: LoginRequest) => {
  auth.tenantId = process.env.REACT_APP_TENANT_ID;

  return signInWithEmailAndPassword(
    auth,
    credentials.email,
    credentials.password
  );
};

const firebaseSignOut = () => {
  return signOut(auth);
};

const getErrorMessage = (error: FirebaseError) => {
  switch (error.code) {
    case "auth/user-not-found":
      return "User not found";

    case "auth/invalid-password":
      return "Wrong password";

    default:
      return "Something went wrong";
  }
};

export { logInWithEmailAndPassword, getErrorMessage, firebaseSignOut };
